export const getClosestIndexInRange = (value: number, list: number[]) => {
  let closestIndex = 0;
  let closestDifference = Math.abs(list[0] - value);

  const exactMatchIndex = list.indexOf(value);
  if (exactMatchIndex > -1) return exactMatchIndex;

  for (let i = 1; i < list.length; i++) {
    const difference = Math.abs(list[i] - value);
    if (difference < closestDifference) {
      closestIndex = i;
      closestDifference = difference;
    }
  }

  return closestIndex;
};
